import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { useAppToast } from "@ui-seeker/app"
import {postSubmit, isEmpty, scrollToComponent, FORMAT_DATE_BACK, formatDate, stringToDate} from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { usePricingChangesRoleConfig } from "../../@hooks"
import { priceChangesPriceEvolutionFilters } from "../../@signals"


export default function usePriceChangesPriceEvolutionData() {
	const { showToast } = useAppToast()
	const { urlApiPriceEvolution } = usePricingChangesRoleConfig()

	const dataEvolution = useSignal({})
	const dataEvolutionKeys = useSignal({})
	const chartColors = useSignal({})
	const skuName = useSignal("")
	const retailer = useSignal("")
	const isLoadingDataEvolution = useSignal(false)
	const currency = useSignal("")
	const evolutionDatePeriod = useSignal(DATE_PERIODS.LAST_7_DAYS)
    const dateRange = useSignal([])

    useEffect(() => {
		if (!isEmpty(priceChangesPriceEvolutionFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(urlApiPriceEvolution, priceChangesPriceEvolutionFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chartData
				dataEvolutionKeys.value = res.chartKeys
				chartColors.value = res.chartColors
				skuName.value = res.skuName
				currency.value = res.currency
				retailer.value = res.retailer
                dateRange.value = [stringToDate(priceChangesPriceEvolutionFilters.value.startDate), stringToDate(priceChangesPriceEvolutionFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-price-chart')))
		}) 

		if (isEmpty(priceChangesPriceEvolutionFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
			chartColors.value = {}
			skuName.value = ""
			currency.value = ""
			retailer.value = ""
			evolutionDatePeriod.value = DATE_PERIODS.LAST_7_DAYS
		})

	}, [JSON.stringify(priceChangesPriceEvolutionFilters.value)])

    const onChangeDate = (e) => {
        batch(() => {
            dateRange.value = e
            priceChangesPriceEvolutionFilters.value = {
                ...priceChangesPriceEvolutionFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		chartColors.value = {}
		skuName.value = ""
		retailer.value = ""
		currency.value = ""
		priceChangesPriceEvolutionFilters.value = {}
		evolutionDatePeriod.value = DATE_PERIODS.LAST_7_DAYS
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		currency: currency.value,
		skuName: skuName.value,
		chartColors: chartColors.value,
		retailer: retailer.value,
        dateRange: dateRange.value,

        onChangeDate,
        resetEvolutionData
	}
}